import * as React from "react";
import {useState} from "react";
import {AutosuggestComponentProps} from "../../types/types";
import Autosuggest from "react-autosuggest";
import {useLeadStore} from "../leadgeneration/store/Lead.store";
import useBelfiusTheme from "../leadgeneration/theme/ThemeHooks";

const getSuggestionValue = ( suggestion: any ) => suggestion.label;

const renderSuggestion = ( suggestion: any ) => (<span>{suggestion.label}</span>);

let theme: any = {
    container: {
        position: 'relative'
    }, input: {
        display: 'block',
        width: '100%',
        height: 'calc(1.5em + 0.75rem + 2px)',
        padding: '.375rem .75rem',
        fontSize: '0.875rem',
        fontWeight: 'normal',
        color: '#555',
        backgroundColor: '#fff',
        backgroundClip: 'padding-box',
        lineHeight: 1.5,
        border: '1px solid #ced4da',
        borderColor: '#e9e9e9',
        borderRadius: 0
    }, inputFocused: {
        outline: 'none', color: "#555", backgroundColor: '#fff', borderColor: '#29B58F', boxShadow: '0 0 0 0.2rem rgb(195 0 69 /25%)'
    }, inputInvalid: {
        borderColor: '#dd000c',
        paddingRight: 'calc(1.5em + 0.75rem)',
        backgroundImage: 'url(data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'%23dd000c\' viewBox=\'-2 -2 7 7\'%3e%3cpath stroke=\'%23dd000c\' d=\'M0 0l3 3m0-3L0 3\'/%3e%3ccircle r=\'.5\'/%3e%3ccircle cx=\'3\' r=\'.5\'/%3e%3ccircle cy=\'3\' r=\'.5\'/%3e%3ccircle cx=\'3\' cy=\'3\' r=\'.5\'/%3e%3c/svg%3E)',
        backgroundRepeat: 'no-reperat',
        backgroundPosition: 'center right calc(0.375em + 0.1875rem)',
        backgroundSize: 'calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)'
    }, inputOpen: {
        borderBottomLeftRadius: 0, borderBottomRightRadius: 0
    }, suggestionsContainer: {
        display: 'none'
    }, suggestionsContainerOpen: {
        display: 'block',
        position: 'absolute', top: 35, width: '100%',
        border: '1px solid #aaa',
        backgroundColor: '#fff',
        fontFamily: 'Helvetica, sans-serif',
        fontWeight: 300,
        fontSize: 16,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        zIndex: 2
    }, suggestionsList: {
        margin: 0, padding: 0, listStyleType: 'none',
    }, suggestion: {
        cursor: 'pointer', padding: '10px 20px'
    }, suggestionHighlighted: {
        backgroundColor: '#ddd'
    }
};

const AUTOSUGGEST_SELECTION_EVENTS = ['click', 'down', 'up'];

function isSelection( eventName: string ): boolean
{
    return AUTOSUGGEST_SELECTION_EVENTS.filter( x => x === eventName ).length > 0;
}

export const AutosuggestComponent = ( {onChange, placeholder}: AutosuggestComponentProps ) => {
    const [isValid, setIsValid] = useState( true );
    const [suggestions, setSuggestions] = useState( [] );
    const [value, setValue] = useState( '' );
    const [clickedValue, setClickedValue] = useState( '' );
    const store = useLeadStore();

    const onBlur = function ( e: any ) {
        const trimmedValue = e.target.value.trim();
        if ( trimmedValue === "" ) {
            setIsValid( false );
        }
        else if ( clickedValue !== value ) {
            setValue( '' );
            onChange( '' );
            setIsValid( false )
        }
        else {
            setIsValid( true );
        }
    };

    // @ts-ignore
    const handleOnChange = ( event: any, {newValue, method} ) => {
        console.log( event, newValue, method );
        setValue( newValue );
        if ( isSelection( method ) ) {
            onChange( newValue );
            setClickedValue( newValue );
        }
        else if ( clickedValue !== '' ) {
            setClickedValue( '' );
        }
    };

    // @ts-ignore
    const onSuggestionsFetchRequested = ( {value} ) => {
        fetch( `/api/myIzenApplicationModule/auto-suggest/query?query=${value}&controlName=entity.postalCode&dataset=entity-postalCode` )
            .then( response => response.json() )
            .then( data => {
                const suggestions = (data || []).slice( 0, 10 );
                setSuggestions( suggestions );
            } )
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions( [] );
    };

    const inputProps = {
        placeholder: placeholder, value, onChange: handleOnChange, onBlur: onBlur, className: theme
    };

    // dirty hack to change styling
    let {belfiusThemeState} = useBelfiusTheme();
    theme.inputFocused.boxShadow = belfiusThemeState ? '0 0 0 0.2rem rgb(195 0 69 /25%)' : '0 0 0 0.2rem rgb(41 181 143 /25%)';

    return (<div className={`izen-autosuggest ${!isValid ? 'is-invalid' : ''}`}>
        <Autosuggest
            theme={theme}
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}/>
        {!isValid && <div className="invalid-feedback">
            {store.translate( 'leadgeneration.validation.required' )}
        </div>}
    </div>);
};
